const linkWithCredentials = (link) => {
  /* eslint-disable no-console */
  console.warn('localStorage access');
  /* eslint-enable no-console */

  const credentials = JSON.parse(localStorage.getItem('credentials'));

  // eslint-disable-next-line arrow-body-style
  const queryParams = Object.entries(credentials).map(([key, value]) => `${key}=${value}`).join('&');
  return `${link}?${queryParams}`;
};


export default linkWithCredentials;
